import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ArrowUpSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ArrowUpSVG;
